import { render } from "./ZReportDetails.vue?vue&type=template&id=c65b726c&scoped=true"
import script from "./ZReportDetails.vue?vue&type=script&lang=js"
export * from "./ZReportDetails.vue?vue&type=script&lang=js"

import "./ZReportDetails.vue?vue&type=style&index=0&id=c65b726c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65b726c"]])

export default __exports__